// extracted by mini-css-extract-plugin
export var text = "Text-module--text--3eeuA";
export var spinAround = "Text-module--spinAround--i9gaC";